export default __webpack_public_path__ + "static/media/SFProText-Medium-1.fc3c323b.ttf";